export default "__VITE_ASSET__CEMWzTur__"